import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, ListGroup, ListGroupItem, Nav, NavItem, Panel, Row} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';

import './style.css';

const masonryOptions = {
    transitionDuration: 0
};

class DashboardSidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active_page: this.props.active_page,
            show_category_dropdown: false
        }
    }
    

    render() {

        const category_dropdown = (
            <React.Fragment>
                <div style={{height: '100vh', width: '100vw', position: 'fixed', top: 0, left: 0, zIndex: '1000'}} onClick={() => this.setState({show_category_dropdown: false})}></div>
                <Panel className="thin_scroll" style={{height: '40vh', overflowY: 'auto', position: 'absolute', marginTop: 10, marginRight: 10, marginLeft: '-10px', zIndex: '1500'}}>
                    <ListGroup>
                        {this.props.template_categories && this.props.template_categories.map((category,idx) => (
                            <ListGroupItem key={idx} style={{fontFamily: 'Montserrat', fontWeight: '400', fontSize: 14}} onClick={() => this.props.design_template_on_click(category.example, category)}>{category.name}</ListGroupItem>
                        ))}
                    </ListGroup>
                </Panel>
            </React.Fragment>
        );

        const styles = {
            nav_text: {
                fontFamily: 'Montserrat', 
                color: '#756A60',
                marginLeft: 27,
                fontSize: 16
            },
            nav_active: {
                color: '#FF841F',
                borderBottom: 'solid 2px'
            }
        }
        return (
            <div style={{width: 'inherit', height: '-webkit-fill-available', position: 'fixed', backgroundColor: 'white'}}>
                <Row style={{marginLeft: 30, 'marginTop': '10px', paddingTop: 38}}>
                    
                    <Button onClick={() => this.setState({show_category_dropdown: true})} style={{ fontSize: 16, paddingTop: 8, paddingBottom: 8, paddingLeft: 28, paddingRight: 28, fontFamily: 'Montserrat', fontWeight: 500 }} className="btn-orange"><span className="fa fa-sm fa-plus"/> Generate New</Button>
                    {this.state.show_category_dropdown && category_dropdown}
                    <br />
                    <div>
                        
                    </div>
                    <Nav style={{ marginTop: 33, paddingRight: 11 }} stacked activeKey={this.state.active_page} >
                        <LinkContainer to="/designmaker/start">
                            <NavItem onClick={() => this.setState({active_page: "designs"})} className={this.state.active_page == "designs" ? "dashboard_nav dashboard_active_nav" : "dashboard_nav"} >
                                <span  className={this.state.active_page == "designs" ? "text-orange" : ""} style={styles.nav_text}>Dashboard</span>
                                 <div style={{ display: this.state.active_page == 'designs' ? 'block' : 'none'}} className="dashboard_active_nav_indicator" />
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to="/designmaker/start/templates">
                            <NavItem onClick={() => this.setState({active_page: "templates"})} className={this.state.active_page == "templates" ? "dashboard_nav dashboard_active_nav" : "dashboard_nav"} >
                                <span className={this.state.active_page == "templates" ? "text-orange" : ""} style={styles.nav_text} >Templates</span>
                                 <div style={{ display: this.state.active_page == 'templates' ? 'block' : 'none'}} className="dashboard_active_nav_indicator" />
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to="/designmaker/start/wizard">
                            <NavItem onClick={() => this.setState({active_page: "wizard"})} className={this.state.active_page == "wizard" ? "dashboard_nav dashboard_active_nav" : "dashboard_nav"} >
                                <span className={this.state.active_page == "wizard" ? "text-orange" : ""} style={styles.nav_text} >Wizard</span>
                                 <div style={{ display: this.state.active_page == 'wizard' ? 'block' : 'none'}} className="dashboard_active_nav_indicator" />
                            </NavItem>
                        </LinkContainer>
                        {this.props.user && (
                            <React.Fragment>
                                {/*<LinkContainer to="/designmaker/start/brand-kit">
                                    <NavItem onClick={() => this.setState({active_page: "brand_kit"})} className={this.state.active_page == "brand_kit" ? "dashboard_nav dashboard_active_nav" : "dashboard_nav"} >
                                        <span className={this.state.active_page == "brand_kit" ? "text-orange" : ""} style={styles.nav_text} >Brand Kit</span>
                                         <div style={{ display: this.state.active_page == 'brand_kit' ? 'block' : 'none'}} className="dashboard_active_nav_indicator" />
                                    </NavItem>
                                </LinkContainer>*/}
                                
                                <LinkContainer to="/designmaker/start/shared-designs">
                                    <NavItem onClick={() => this.setState({active_page: "shared-designs"})} className={this.state.active_page == "shared-designs" ? "dashboard_nav dashboard_active_nav" : "dashboard_nav"} >
                                        <span className={this.state.active_page == "shared-designs" ? "text-orange" : ""} style={styles.nav_text} >Shared with me</span>
                                         <div style={{ display: this.state.active_page == 'shared-designs' ? 'block' : 'none'}} className={"dashboard_active_nav_indicator"} />
                                    </NavItem>
                                </LinkContainer>
                                <LinkContainer to="/designmaker/start/folders">
                                    <NavItem onClick={() => this.setState({active_page: "folders"})} className={this.state.active_page == "folders" ? "dashboard_nav dashboard_active_nav" : "dashboard_nav"} >
                                        <span className={this.state.active_page == "folders" ? "text-orange" : ""} style={styles.nav_text} >Folders</span>
                                        <div style={{ display: this.state.active_page == 'folders' ? 'block' : 'none'}} className="dashboard_active_nav_indicator" />
                                    </NavItem>
                                </LinkContainer>
                                <LinkContainer to="/designmaker/start/design-orders">
                                    <NavItem onClick={() => this.setState({active_page: "orders"})} className={this.state.active_page == "orders" ? "dashboard_nav dashboard_active_nav" : "dashboard_nav"} >
                                        <span className={this.state.active_page == "orders" ? "text-orange" : ""} style={styles.nav_text} >Purchases</span>
                                        <div style={{ display: this.state.active_page == 'orders' ? 'block' : 'none'}} className="dashboard_active_nav_indicator" />
                                    </NavItem>
                                </LinkContainer>
                            </React.Fragment>    
                        )}
                      </Nav>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state, own_props) => ({
    user: state.user,
    ...own_props
}) 

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch({type: 'none'})
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSidebar);